export const NS_BITRISE_API_TOKEN = 'com.br.website.token';
export const NS_BITRISE_CSRF_TOKEN = 'CSRF-TOKEN';
export const NS_BITRISE_SESSION = '_concrete_website_session';
export const NS_FIREBASE_TOKEN = 'com.br.firebase.token';
export const NS_TRACE_APP = 'com.br.trace.app';
export const NS_TRACE_TOKEN = 'com.br.trace.token';
